import Cropper from './src/cropper';

export default Cropper;
